import React from 'react';
import { ListActionSwitch } from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

export const CheckoutPaymentBlockAvailableCredit = ({
  credit,
  availableCredit,
  enabled,
  onAvailableCreditSelected,
}: CheckoutPaymentBlockAvailableCreditProps) => {
  const { t, formatPrice } = useLocalizationContext();

  if (!credit) return null;
  const creditText = t('checkout.available-credit', {
    amount: formatPrice(credit, 'USD'),
    available: formatPrice(availableCredit, 'USD'),
  });

  return (
    <ListActionSwitch
      iconName="IconSweetgreen"
      title={t('checkout.use-credit')}
      text={creditText}
      value={enabled}
      onChange={onAvailableCreditSelected}
    />
  );
};

type CheckoutPaymentBlockAvailableCreditProps = {
  readonly enabled: boolean;
  readonly credit: number;
  readonly availableCredit: number;
  readonly onAvailableCreditSelected: () => void;
};
